<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
	<div>
	    <Row class="expand-row" v-for="childItem in row">
        <Col span="2">
          <span class="expand-key" style="color:#2d8cf0">ID:</span>
          <span class="expand-value" v-text="childItem.menuId"></span>
        </Col>
	        <Col span="4">
	            <span class="expand-key" style="color:#2d8cf0">{{langMap.name[lang]}}:</span>
	            <span class="expand-value" v-text="childItem.title"></span>
	        </Col>
	        <Col span="3">
	            <span class="expand-key" style="color:#2d8cf0">{{langMap.route[lang]}}:</span>
	            <span class="expand-value" v-text="childItem.path"></span>
	        </Col>
	        <Col span="3">
	            <span class="expand-key" style="color:#2d8cf0">{{langMap.path[lang]}}:</span>
	            <span class="expand-value" v-text="childItem.name"></span>
	        </Col>
			<Col span="3">
				<span class="expand-key" style="color:#2d8cf0">{{langMap.isView[lang]}}:</span>
				<span class="expand-value" v-text="childItem.showFlag ? langMap.yes[lang] : langMap.no[lang]"></span>
			</Col>
        <Col span="3">
          <span class="expand-key" style="color:#2d8cf0">{{langMap.icon[lang]}}:</span>
          <span class="expand-value" v-text="childItem.icon"></span>
        </Col>
        <Col span="2">
          <span class="expand-key" style="color:#2d8cf0">{{langMap.sort[lang]}}:</span>
          <span class="expand-value" v-text="childItem.att.menuOrder"></span>
        </Col>
	        <Col span="4">
	            <Button type="text" style="padding: 1px;color: #2d8cf0" size="small" @click="removeMenu(childItem)">{{langMap.delete[lang]}}</Button>
              <Divider type="vertical" style="margin: 0 2px"/>
	            <Button style="padding: 1px;color: #2d8cf0" v-if="childItem.att.menuState==1" type="text" size="small" @click="chengeMenuState(childItem)">{{langMap.disable[lang]}}</Button>
	            <Button style="padding: 1px;color: #2d8cf0" v-if="childItem.att.menuState!=1" type="text" size="small" @click="chengeMenuState(childItem)">{{langMap.enable[lang]}}</Button>

	        </Col>
	    </Row>
	</div>
</template>

<script>
//引入api
import api from "../../../api/index.js"
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
    props: {
        row: Array
    },
	data(){
		return {
			langMap: langMap
		}
	},
    computed: {
        ...mapState({
            lang: state => state.app.language,
        }),
    },
    methods: {
    	//添加菜单
    	removeMenu(childItem){
    		this.$Modal.confirm({
        		title:langMap.systemTip[this.lang],
        		content:langMap.deleteMenuConfirm[this.lang],
				okText: langMap.confirm[this.lang],
				cancelText: langMap.cancel[this.lang],
        		onOk:()=>{
        			this.$Spin.show();
					api.getData("system-server/sys/removeMenu?menuId="+childItem.menuId,this).then((res)=>{
		    			if(res.state==0){
		    				this.$Notice.error({
			                    title: langMap.tip[this.lang],
			                    desc:res.msg,
			                });
		    			}else{
		    				//子组件发送广播，重载数据
		    				this.$emit('refreshList');
		    			}
		    			this.$Spin.hide();
		    		})
        		}
        	})
    	},
    	/**
    	 *修改菜单状态
    	 */
    	chengeMenuState(childItem){
    		this.$Modal.confirm({
        		title:langMap.systemTip[this.lang],
        		content:langMap.whetherToChangeMenuState[this.lang],
				okText: langMap.confirm[this.lang],
				cancelText: langMap.cancel[this.lang],
        		onOk:()=>{
        			this.$Spin.show();
					api.getData("system-server/sys/updateMenuState?menuId="+childItem.menuId,this).then((res)=>{
		    			if(res.state==0){
		    				this.$Notice.error({
			                    title: langMap.tip[this.lang],
			                    desc:res.msg,
			                });
		    			}else{
		    				//子组件发送广播，重载数据
		    				this.$emit('refreshList');
		    			}
		    			this.$Spin.hide();
		    		})

        		}
        	})
    	}



    }
};
</script>

<style>
</style>
